import { render, staticRenderFns } from "./password_success.vue?vue&type=template&id=6b4b2967&scoped=true"
import script from "./password_success.vue?vue&type=script&lang=js"
export * from "./password_success.vue?vue&type=script&lang=js"
import style0 from "./password_success.vue?vue&type=style&index=0&id=6b4b2967&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4b2967",
  null
  
)

export default component.exports